import { getCloudinaryImageUrl } from '@utils/images'
import styled from 'styled-components'
import Typewriter from 'typewriter-effect'

const Module1 = (props: any) => {
  return (
    <StyledComponent $headerBackgroundImage={props.headerBackgroundImage} className=''> {/* 70 is to compensate the header space */}
      <div className='snap-section-start theme-transparent show-floating-logos' />
      {/* Tailwind that occupies full width and full height depending on screen size */}
      <div className='slide-wrapper w-100 bg-gray-100 flex items-center justify-center background-image'>
        <MainText className='w-screen'>
          <div className='small-texts relative -top-[1px] lg:-top-[0px]'>
            {/* divide in 3 columns */}
            <div className='flex justify-center'>
              <div className='w-1/3 flex justify-center items-center'>
                <div className={`text-1xl font-thin small-text`}>
                  {props.headerTextLeft}
                </div>
              </div>
              <div className='w-1/3 flex justify-center items-center'>
                <div className={`text-1xl font-thin small-text`}>
                  {props.headerTextCenter}
                </div>
              </div>
              <div className='w-1/3 flex justify-center items-center'>
                <div className={`text-1xl font-thin small-text`}>
                  {props.headerTextRight}
                </div>
              </div>
            </div>
          </div>
          <div className={`text-center uppercase large-text relative top-[2px] lg:top-[3px]`}>
            <Typewriter
              onInit={(typewriter) => {
                typewriter.typeString(props.headerLargeText)
                  .callFunction(() => { })
                  .start()
              }}
            />
          </div>
        </MainText>
      </div>
    </StyledComponent>
  )
}

const StyledComponent = styled.div<any>`
  @media (min-width: 1024px) {
    scroll-snap-align: start;
  }
  
  > div.slide-wrapper {
    height: 100vh;
  }

  .background-image {
    background-image: url(${(props) => props.$headerBackgroundImage?.data?.attributes.url && getCloudinaryImageUrl(props.$headerBackgroundImage?.data?.attributes.url, 'q_auto,dpr_1.0,f_auto,fl_progressive')});
    background-size: cover;
    background-repeat: repeat;
    background-position: center;


    // Media query for desktop, ready for any future changes
    @media (min-width: 768px) {
      
    }
  }
`

const MainText = styled.div`
  background: white;
  .small-texts {
    .small-text {
      line-height: 1vh;
      font-size: 1.7vh;
      font-family: var(--swintonfont);
      position: relative;
      top: 3px;

      // Media query for desktop
      @media (min-width: 768px) {
        font-size: 2.7vh;
        line-height: 1.5vh;
        top: 3px;
      }
    }
  }

  @media (min-width: 1024px) {
    margin-top: 100px;
  }

  .large-text {
    font-size: 5vh;
    font-family: var(--abcdfont);
    line-height: 3.9vh;

    // Media query for desktop
    @media (min-width: 768px) {
      font-size: 10vh;
      line-height: 7.3vh;
    }
  }
`

export default Module1